import { UserPlus } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { UserManagement } from "@/components/dashboard/superadmin/UserManagement"
import { Page, PageHeader } from "@/components/superadmin/kit"
import { SuperAdminLayout } from "@/components/superadmin/SuperAdminLayout"
import { Button } from "@/components/ui/button"

const UsersPage = () => {
  const navigate = useNavigate()
  return (
    <SuperAdminLayout>
      <Page>
        <PageHeader
          title="Usuários"
          description="Contas de todas as organizações. Clique numa linha para ver acesso, contato, vínculo e atividade."
          actions={<Button className="h-9 gap-1.5" onClick={() => navigate("/superadmin/usuarios?novo=1")}><UserPlus className="h-4 w-4" />Novo usuário</Button>}
        />
        <UserManagement />
      </Page>
    </SuperAdminLayout>
  )
}

export default UsersPage
